import React,{useContext,useEffect,useState} from 'react';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import CartaContext from '../../context/cartaContext/cartaContext';
import AuthContext from '../../context/authContext/authContext';
import AdminContext from '../../context/adminContext/adminContext';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import DeleteIcon from '@material-ui/icons/Delete';
import { makeStyles } from '@material-ui/core/styles';
import MuiAlert from '@material-ui/lab/Alert';
import {
    Container,
    Button,
    Stepper,
    Typography,
    Step,
    StepLabel,
    StepContent,
    Card,
    AccordionSummary,
    Accordion,
    AccordionDetails,
    FormGroup,
    Checkbox,
    CardContent,
    CardActions,
    CircularProgress,
    Snackbar,
    TextField,
    Dialog,
    DialogContent,
    DialogContentText,
    DialogActions,
    DialogTitle,
    Backdrop,
    TextareaAutosize,
    useMediaQuery,
    Paper,
    Box,
    IconButton

} from '@material-ui/core'
import AdminLayout from './AdminLayout';

//ESTILOS
const useStyles = makeStyles((theme) => ({
    cabecera:{
        padding : '2rem',
        [theme.breakpoints.up('md')]: {
            fontSize : "16px"
        }
    },
    borrarIngrediente: {
        display :'flex',
        justifyContent : 'space-between',
        alignContent : 'center',
        alignItems : 'center',
        "& p" : {
            alignItems : 'center'
        }
    },
    radio : {
        display : 'flex',
        flexDirection : 'column',
        textTransform : 'capitalize',
        padding : '4px 8px 8px',
        width : '100%',
        [theme.breakpoints.up('sm')] : {
            flexDirection : 'row',
            flexWrap : 'wrap'
        }
        
        
    },
    form : {
        textTransform : 'capitalize',
        
    },
    grupoRadio : {
        width : '100%',
        textTransform: 'capitalize',
        display : 'flex',
        
    },
    stepper :{
        padding : '10px',
        marginTop : '10px'
    },
    botonera : {
        padding : '5px',
        margin: '5px',
        '& button' : {
            margin : '.8rem'
        }
    },
    botones : {
        width: "100%",
        display : "flex",
        justifyContent: "center"
    },
    circular : {
        display: 'flex',
        '& > * + *': {
        marginLeft: theme.spacing(2),
            },
    },
    precio : {
        fontWeight : 'bold',
        color: "black"
    },
    card : {
        margin : '1rem',
        width: '95%'
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
      },
    ingredientes : {
        width : '100%',
        display : 'flex',
        height:'200px',
        flexGrow : 1,
        textTransform : 'capitalize',
        alignItems:'flex-start',
        paddingLeft : '1rem',
        [theme.breakpoints.down('sm')] : {
            flexDirection : 'column',
            height : '100%'
        }

    },
    listadoBebidas: {
        display : 'flex',
        marginBottom : '1rem',
        textTransform : 'capitalize',
        padding : '1rem'
    },
    bebida : {
        display : 'flex',
        alignItems : 'center',
        padding : '1rem'
    },
    bebida_input : {
        width : '15%',
        marginLeft : '1rem',
    },
    area : {
        marginTop : '1rem',
        '& textarea ':{
            resize: 'none',
            width : '100%'
          }
    },
    titulo : {
        textTransform : 'uppercase',
        textAlign : 'center'
    },
    descripcion : {
        marginLeft : '.5rem',
        textTransform : 'capitalize'
    },
    platos : {
        display : 'flex',
        width : '100%',
        flexDirection : 'column',
        [theme.breakpoints.up('sm')] : {
            flexDirection : 'column',
            flexWrap : 'wrap'
        }
        
    },
    plato : {
        width : '100%',
        [theme.breakpoints.up('sm')] : {
            width : '45%'
        }
        
    }

}));

//ALERTAS
function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }

//TITULOS STEPPER
function getSteps() {
    return ['Elegi Menu', 'Elegi tu ingrediente'];
  }
  

const NewPedido = (props) => {
    const matches = useMediaQuery('(min-width:600px)');   
    //STATE DEL CONTEXT MENU
        const cartaContext = useContext(CartaContext);
        const {
            bebidas,
            bebidaSalon,
            ingredientes,
            platos,
            cargando,
            obtenerMenuStock,
            } = cartaContext
        //STATE DEL CONTEXT AUTH
        const authContext = useContext(AuthContext);
        const {
            cliente,
            autenticado,
            mensaje,
            error,
            carrito,
            total_carrito,
            addCarrito,
            deleteCarrito,
            reiniciarErrorMensaje,
            checkOut,
            getCarrito,
            deleteBebida,
            erroresForm,
            errorStepper,
            limpiarCarrito
            } = authContext; 
    //STATE DEL CONTEXT ADMIN
    const adminContext = useContext(AdminContext);
    const {error_pedido, crearPedido} = adminContext;
    //STATES LOCALES
    const classes = useStyles()
    const [especial, setespecial] = useState(false);
    const [formulario, setFormulario] = useState([
        {
            platos: null,
            ingredientes : [],
            bebidas: []
        }
    ]);
    const [clienteManual, setClienteManual] = useState({
        nombre : null,
        telefono : null
    });
    const [tipoPlato, settipoPlato] = useState();
    const [activeStep, setActiveStep] = useState(0);
    const [formaentrega, setformaentrega] = useState(null);
    const [domicilio , setDomicilio] = useState({
        calle : null,
        barrio : null,
        referencia : null
    });
    const [formaPago, setformaPago] = useState(null);
    const [Open, setOpen] = useState(false);
    const [isloading, setisloading] = useState(false);
    
    const steps = getSteps();
    //FILTAR CATEGORIAS DE PLATOS
    const filtrar_categorias = [];
    //FILTRAR CATEGORIAS DE BEBIDAS
    const filtrar_bebidas = []
    //OBTENER CATEGORIAS DE PLATOS Y BEBIDAS
    if(!cargando && platos){
        platos.forEach(element => {
            filtrar_categorias.push(element.categoria);
            
        });
        var unique = filtrar_categorias.filter((v, i, a) => a.indexOf(v) === i); 
        
    }
    if(!cargando && bebidaSalon){
        bebidaSalon.forEach(element => {
            filtrar_bebidas.push(element.categoria);
            
        });
        var beb = filtrar_bebidas.filter((v, i, a) => a.indexOf(v) === i); 
        
    }
    //EFFECT     
    useEffect(() => {
            obtenerMenuStock()
            
           
            if(cliente){
                getCarrito(cliente)
                if(cliente.nombre === "mesera" || cliente.nombre === "mesera2"){
                    props.history.push('/admin/salon')
                }
            }
            
            
           // eslint-disable-next-line   
        }, [autenticado,mensaje,open]);   
    
    
    //VISTAS DEL STEPPER
        function getStepContent(step) {
            switch (step) {
              case 0:
                return  <RadioGroup aria-label="gender" name="gender1" className={classes.grupoRadio}>
                                {unique ? unique.map(categoria => {
                                    return  <Accordion key = {categoria} className={classes.platos}>
                                        <AccordionSummary 
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel1a-content"
                                            id="panel1a-header"
                                        >
                                        <Typography >{categoria}</Typography>
                                            </AccordionSummary>
                                            <AccordionDetails className ={classes.radio} >
                                            {platos ? platos.map(plato => {
                                                if(plato.categoria === categoria){
                                                    return <FormControlLabel 
                                                                key={plato._id} 
                                                                value={plato._id}
                                                                name = {plato.nombre }
                                                                checked = {formulario[0].platos === plato._id ? true : false} 
                                                                control={<Radio />} 
                                                                label={`${plato.nombre}    $ ${plato.precio}`} 
                                                                onChange={platoChange}
                                                                labelPlacement = 'end'
                                                                className= {classes.plato}
                                                                />
                                                            
                                                    
                                                }
                                                return null
                                            })
                                            : <CircularProgress className={classes.circular} color="secondary" />
                                            }
                                            </AccordionDetails>
                                       </Accordion>
                                     
                                }) 
                                :<div className={classes.circular}><CircularProgress  color="secondary" /></div>}
                               
                        </RadioGroup>
              case 1:
                return  <Paper>{tipoPlato === "milanesa" || tipoPlato === "hamburguesa" ? <FormGroup className={classes.ingredientes}>
                            {ingredientes ? ingredientes.map(ingrediente => {
                                if(tipoPlato === "milanesa" && ingrediente.precio_milanesa ){
                
                                    return <FormControlLabel
                                            key={ingrediente._id}
                                            checked = {formulario[0].ingredientes.includes(ingrediente._id)}
                                            control={<Checkbox   value={ingrediente._id} name={ingrediente.nombre} />}
                                            label={tipoPlato === "hamburguesa" ? `${ingrediente.nombre}  $ ${ingrediente.precio_hamburguesa}` 
                                                                : `${ingrediente.nombre}  $ ${ingrediente.precio_milanesa}` }
                                            onChange={ingredienteChange}
                                        />
                                    }
                                if(tipoPlato === "hamburguesa" ){
                                    return <FormControlLabel
                                    key={ingrediente._id}
                                    checked = {formulario[0].ingredientes.includes(ingrediente._id)}
                                    control={<Checkbox   value={ingrediente._id} name={ingrediente.nombre} />}
                                    label={tipoPlato === "hamburguesa" ? `${ingrediente.nombre}  $ ${ingrediente.precio_hamburguesa}` 
                                                        : `${ingrediente.nombre}  $ ${ingrediente.precio_milanesa}` }
                                    onChange={ingredienteChange}
                                />
                                }
                                return null    
                                    })
                            : <CircularProgress className={classes.circular} color="secondary" />
                            }
            
                        </FormGroup>
                        : <Typography color='error'>Al menu seleccionado no se le pueden colocar ingredientes.</Typography>
                        }</Paper>  
    
              default:
                return 'Opcion invalida recarga la pagina';
            }
        };
    //FUNCIONES PARA STATE

    const domicilioChange = (e) => {
        setDomicilio({
            ...domicilio,
            [e.target.id] : e.target.value
        })
    };
    const clienteChange = (e) => {
        setClienteManual({
            ...clienteManual,
            [e.target.id] : e.target.value
        })
        
    }  
    const platoChange = (e) => {
      platos.map(plato =>{
          if(plato._id === e.target.value){
            settipoPlato(plato.categoria)
          }
          return null 
    })
       
        const newArray = [];
        const plato = e.target.value;
        newArray.push({platos : plato,
                     ingredientes : [],  
                     bebidas : []
                    });
        setFormulario(newArray)
        if(e.target.value === "5fb807ca72e3cf2886f5d707" || e.target.value === "5fb807e472e3cf2886f5d708" ||  
        e.target.value === "5fb8083172e3cf2886f5d70b" || e.target.value === "5fb8084272e3cf2886f5d70c" ||
        e.target.value === "5fb8086a72e3cf2886f5d70d" || e.target.value === "5fb8088b72e3cf2886f5d70e" ||
        e.target.value === "5fc2c4deafc7b90017c6e14d" ){
            setespecial(true)
        }else{
            setespecial(false)
        }
    };
    const ingredienteChange = (e) => {
        const newArray = [...formulario]
        const ingrediente = newArray[0].ingredientes
        if (e.target.checked) {
            ingrediente.push(e.target.value);
        } else {
                const idx = ingrediente.indexOf(e.target.value);
            if(idx > -1){
                ingrediente.splice(idx, 1);
            }
            
        }
        
        newArray[0].ingredientes = ingrediente
        setFormulario(newArray)
    };
    const bebidaChange = (e) => {
      
        const newArray = [...formulario]
        const bebida = newArray[0].bebidas
        
        if(bebida.find(indx => indx === e.target.id)){
            bebida.splice(0);
            for (let index = 0; index < e.target.value; index++) {
                bebida.push(e.target.id)
            }
        }else{
            for (let index = 0; index < e.target.value; index++) {
                bebida.push(e.target.id)
            }
        }
        // if (e.target.checked) {
        //     bebida.push(e.target.value);
        // } else {
        //         const idx = bebida.indexOf(e.target.value);
        //     if(idx > -1){
        //         bebida.splice(idx, 1);
        //     }
            
        // }
        newArray[0].bebidas = bebida
         setFormulario(newArray)
    };
    const entregaChange = (e) =>{
        setformaentrega(e.target.value)
    };
    const handleClose = () => {
        reiniciarErrorMensaje()
    };
    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };
    const handleBack = () => {
        setFormulario([
            {
                platos: null,
                ingredientes : [],
                bebidas: []
            }])
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
        
    };
    const eliminarMenu = async id => {
        setisloading(true)
        await deleteCarrito(id , cliente)
        if(carrito.length === 1){
            setActiveStep(0)
            setFormulario(
                [{
                    platos: null,
                    ingredientes : [],
                    bebidas: []
                }]
            )
            setOpen(false)
        }
        setisloading(false)
        
    };
    const agregarOtroMenu = async e => {
        setisloading(true)
        await addCarrito(formulario[0],cliente)
        setFormulario([
            {
                platos: null,
                ingredientes : [],
                bebidas: []
            }
            ]);
        settipoPlato();
        setActiveStep(0)
        setespecial(false)
        setisloading(false)
    };

    //ABRIR CONFIRMACION DE PEDIDO
    const confirmarPedido = async e => {
        if(formaPago === "mercado_pago"){
            setisloading(true)
           await checkOut()
            setisloading(false)
           setOpen(true)
           
        }else {
            //VALIDAR CAMPOS
                if(clienteManual.nombre === null || clienteManual.nombre === ""){
       
                erroresForm()
                return
            }
             if( formulario[0].platos == null && formulario[0].bebidas.length === 0 && carrito.length === 0 ){
        
                errorStepper()
                return
            } 
            
           //SEPARAR BEBIDAS DEL CARRITO
           const bebidas = {
            platos : null,
            ingredientes : [],
            bebidas : formulario[0].bebidas
            }
        let menu = formulario[0];
        menu.bebidas = [];
        if(menu.platos){
            await addCarrito(menu,cliente)
        }    
        if(bebidas.bebidas.length > 0){
            await addCarrito(bebidas, cliente)
        }
      
        
        settipoPlato();
        setActiveStep(0)
        setisloading(false)
        setOpen(true)

        }
        
    };
    //FINALIZAR PEDIDO
    const finalizarPedido = async e => {
        setisloading(true);
        setOpen(false)
        await crearPedido(carrito, domicilio,formaentrega,formaPago,total_carrito,clienteManual)
        await limpiarCarrito(cliente)
       
        
        setTimeout(
            function(){
                setisloading(false);
                if (error_pedido === null) {
                    props.history.push('/admin')
                }else{
                    return
                }
            }
           ,
            3000
        )
        
    };
    //CANCELAR ORDEN
    const cancelOrder = async e => {
        setisloading(true)
        setFormulario([
            {
                platos: null,
                ingredientes : [],
                bebidas: []
            }])
        setOpen(false)
        setActiveStep(0)
        setisloading(false)
     

       
    };
    //DUPLICAR MENU
    const duplicateMenu = async menu => {
    let duplicar = {
        platos : null,
        ingredientes : [],
        bebidas : [],
        copia : menu._id
    }
    if(menu.platos){
        duplicar.platos = menu.platos._id;
    }
    if(menu.ingredientes.length > 0){
        menu.ingredientes.forEach(ingrediente => {
            duplicar.ingredientes.push(ingrediente._id)
        });
        
    }
    if(menu.bebidas.length > 0){
        menu.bebidas.forEach(bebida => {
            duplicar.bebidas.push(bebida._id)
        });
    }
    await addCarrito(duplicar , cliente)
    }
    //ELIMINAR BEBIDA
    const eliminarBebida = async id => {
        setisloading(true)
        deleteBebida(cliente , id)
        setisloading(false)
    }
    return ( 
        <AdminLayout>
        <Backdrop className={classes.backdrop} open={isloading} onClick={handleClose}>
            <CircularProgress color="inherit" />
        </Backdrop>
        
         
          <Snackbar open={mensaje ? true : false} autoHideDuration={4000} 
                    onClose={handleClose}
                    anchorOrigin={ {vertical: 'top', horizontal: 'center'} }>
            <Alert onClose={handleClose} severity="success">
                {mensaje}
            </Alert>
            </Snackbar>
            <Snackbar open={error} autoHideDuration={6000} 
                    onClose={handleClose}
                    anchorOrigin={ {vertical: 'top', horizontal: 'center'} }>
                <Alert onClose={handleClose} severity="error">
                    {mensaje}
                </Alert>
            </Snackbar>
        {matches ?
            <Container maxWidth="md">
                <div >
                    <Typography variant="h3" gutterBottom={true} align='center'>Nuevo delivery</Typography>
                    <div className={classes.cabecera}>
                    <Typography variant="h5" gutterBottom={true}>Datos cliente</Typography>
                        <Paper elevation={2} >
                        <Box m={1} p={1}>
                        <TextField required id="nombre" label="Nombre: " onChange={clienteChange} />
                        </Box>
                        <Box m={1} p={1} >
                        <TextField required id="telefono" label="Celular:" onChange={clienteChange} />
                        </Box>
                        </Paper>
                    </div>
                    <Typography variant="h5" gutterBottom={true}>Tipo de entrega</Typography>
                    <div className={classes.cabecera}>
                        <Paper elevation={2} >
                        <RadioGroup row aria-label="forma_entrega" name="forma_entrega" defaultValue="top">
                            <FormControlLabel
                                value="domicilio"
                                control={<Radio color="secondary" />}
                                label="a domicilio"
                                labelPlacement="start"
                                onChange={entregaChange}
                                checked = {formaentrega === "domicilio"}
                            />
                            <FormControlLabel
                                value="take away"
                                control={<Radio color="secondary" />}
                                label="take away!"
                                labelPlacement="start"
                                onChange={entregaChange}
                                checked = {formaentrega === "take away"}
                            />  
                        </RadioGroup>
                        {formaentrega === "domicilio" ? <div>
                        <Box m={1} p={1}>
                        <TextField required id="calle" label="DOMICILIO:" onChange={domicilioChange} />
                        </Box>
                        <div className = {classes.area}>   
                        <TextareaAutosize 
                            aria-label="minimum height" 
                            rowsMin={3} 
                            placeholder="Referencia del domicilio" 
                            onChange = {domicilioChange}
                            id="referencia"
                            name="referencia"
                            />    
                        </div>
                        </div>  : null}
                       
                    
                    </Paper>
                    </div>
               
                    <Typography variant="h4" align="center" gutterBottom={true}>Para Comer</Typography>
                    <Stepper activeStep={activeStep} alternativeLabel>
                        {steps.map((label) => (
                            <Step key={label}>
                                <StepLabel>{label}</StepLabel>
                            </Step>
                        ))}
                    </Stepper>
                    <div>
                        {activeStep === steps.length ? (
                            <div>hola</div>
                        ) : (
                                <div>
                                    {getStepContent(activeStep)}
                                    
                                    <div className={classes.botonera}>
                                        <Button
                                            disabled={activeStep === 0}
                                            onClick={handleBack}
                                            
                                        >
                                            Atras
                                        </Button>
                                        {
                                            (tipoPlato === "hamburguesa" && activeStep === 0 &&  !especial ) || (tipoPlato === "milanesa" && activeStep === 0 && !especial )? 
                                            <Button variant="contained" color="primary" onClick={handleNext}>
                                               Siguiente
                                            </Button>
                                            : null
                                        }
                                      
                                        {
                                           ( tipoPlato !== "hamburguesa" && tipoPlato !== "milanesa" && tipoPlato !== undefined ) || (  activeStep === 1) || (especial && tipoPlato !== undefined)  ?
                                            <Button variant="contained" color="primary" onClick={() => agregarOtroMenu()}>
                                                Agregar otro menu
                                            </Button>
                                       
                                        :   null
                                        }
                                        
                                    </div>
                                </div>
                            )}
                    </div>
                </div>
                <div>
                <Typography variant="h4" align="center" gutterBottom={true}>Para tomar</Typography>
                <Paper>
                <FormGroup className={classes.listadoBebidas}>
                        {beb ? beb.map(categoria => {
                                return  <Accordion key = {categoria} className = {classes.platos}>
                                    <AccordionSummary 
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1a-content"
                                        id="panel1a-header"
                                    >
                                    <Typography  variant="h6">{categoria === "sin_alcohol" ? "Sin Alcohol" : categoria}</Typography>
                                        </AccordionSummary>
                                        <AccordionDetails className ={classes.radio} >
                                        {bebidaSalon ? bebidaSalon.map(bebida => {
                                            if(bebida.categoria === categoria){
                                                return <div key={bebida._id} className={classes.bebida} >
                                                    <Typography style={{width : '270px'}}>{`${bebida.nombre} $ ${bebida.precio} :`}</Typography>
                                                        <div className={classes.bebida_input}>
                                                            <TextField 
                                                                id={bebida._id}
                                                                type="number"
                                                                 InputLabelProps={{
                                                                        shrink: true,
                                                                }}  
                                                                onChange={bebidaChange}
                                                                name={bebida.nombre } 
                                                                inputProps={
                                                                    {min : "0"}
                                                                }
                                                            />
                                                        </div>
                                                        </div>
                                            }else{
                                                return null
                                            }
                        
                                        })
                                        : <CircularProgress className={classes.circular} color="secondary" />
                                        }
                                        
                                        
                                        </AccordionDetails>
                                   </Accordion>
                                 
                            }) 
                            :<div className={classes.circular}><CircularProgress  color="secondary" /></div>}
            
                      
                    </FormGroup>  
                </Paper>
      
                </div>
                <div>
                    <Button variant="contained" color="primary" fullWidth 
                    disabled={(clienteManual.nombre === null && clienteManual.telefono === null ) ||
                             (clienteManual.nombre === "" && clienteManual.telefono === "") ||
                             (clienteManual.telefono === null ) || (cliente.nombre === null) ||
                              (formaentrega === null ) || (formaentrega === "domicilio" && domicilio.calle === null) ||
                              (carrito.length === 0 && formulario[0].platos === null && formulario[0].bebidas.length === 0) 
                              ? true : false   }
                    onClick={()=>confirmarPedido()}>FINALIZAR ORDEN</Button>
                </div>

            </Container>
            : <Container maxWidth="sm">
            
                    <Typography variant="h3" gutterBottom={true} align="center">Nuevo delivery</Typography>
                    <div className={classes.cabecera}>
                    <Typography variant="h5" gutterBottom={true}>Datos cliente</Typography>
                        <Paper elevation={2} >
                        <Box m={1} p={1}>
                        <TextField required id="nombre" label="Nombre: " onChange={clienteChange} />
                        </Box>
                        <Box m={1} p={1}>
                        <TextField required id="telefono" label="Celular:" onChange={clienteChange} />
                        </Box>
                        </Paper>
                    </div>
                    <Typography variant="h5" gutterBottom={true}>Tipo de entrega</Typography>
                    <div className={classes.cabecera}>
                        <Paper elevation={2} >
                        <RadioGroup row aria-label="forma_entrega" name="forma_entrega" defaultValue="top">
                            <FormControlLabel
                                value="domicilio"
                                control={<Radio color="secondary" />}
                                label="a domicilio"
                                labelPlacement="start"
                                onChange={entregaChange}
                                checked = {formaentrega === "domicilio"}
                            />
                            <FormControlLabel
                                value="take away"
                                control={<Radio color="secondary" />}
                                label="take away!"
                                labelPlacement="start"
                                onChange={entregaChange}
                                checked = {formaentrega === "take away"}
                            />  
                        </RadioGroup>
                        {formaentrega === "domicilio" ? <div>
                        <Box m={1} p={1}>
                        <TextField required id="calle" label="DOMICILIO:" onChange={domicilioChange} />
                        </Box>
                        <div className = {classes.area}>   
                        <TextareaAutosize 
                            aria-label="minimum height" 
                            rowsMin={3} 
                            placeholder="Referencia del domicilio" 
                            onChange = {domicilioChange}
                            id="referencia"
                            name="referencia"
                            />    
                        </div>
                        </div>  : null}
                       
                    
                    </Paper>
                    </div>
               
                    <Typography variant="h4" align="center" gutterBottom={true}>Para Comer</Typography>
                 <Stepper activeStep={activeStep} orientation="vertical" className={classes.stepper}>
                    {steps.map((label, index) => (
                            <Step key={label}>
                                <StepLabel>{label}</StepLabel>
                                <StepContent>
                                    <FormControl component="fieldset" className={classes.form} >
                                        {getStepContent(index)}
                                    </FormControl >
                                    <div className={classes.botonera}>
                                        <Button
                                            disabled={activeStep === 0}
                                            onClick={handleBack}
                                            
                                        >
                                            Atras
                                        </Button>
                                        {
                                            ((tipoPlato === "hamburguesa") && (activeStep === 0 && !especial) ) || ((tipoPlato === "milanesa") && (activeStep === 0 && !especial)) ? 
                                            <Button variant="contained" color="primary" onClick={handleNext}>
                                               Siguiente
                                            </Button>
                                            : null
                                        }
                                      
                                        {
                                           ( (tipoPlato !== "hamburguesa") && (tipoPlato !== "milanesa") && (tipoPlato !== undefined )) || (activeStep === 1) || (especial && tipoPlato !== undefined)?
                                            <Button variant="contained" color="primary" onClick={() => agregarOtroMenu()}>
                                                Agregar otro menu
                                            </Button>
                                       
                                        :   null
                                        }
                                        
                                    </div>
                                </StepContent>
                            </Step>
                    ))}
        </Stepper>
        <div>
                <Typography variant="h4" align="center" gutterBottom={true}>Para tomar</Typography>
                <Paper>
                <FormGroup className={classes.listadoBebidas}>
                        {beb ? beb.map(categoria => {
                                return  <Accordion key = {categoria} className = {classes.platos}>
                                    <AccordionSummary 
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1a-content"
                                        id="panel1a-header"
                                    >
                                    <Typography  variant="h6">{categoria === "sin_alcohol" ? "Sin Alcohol" : categoria}</Typography>
                                        </AccordionSummary>
                                        <AccordionDetails className ={classes.radio} >
                                        {bebidas ? bebidas.map(bebida => {
                                            if(bebida.categoria === categoria){
                                                return <div key={bebida._id} className={classes.bebida} >
                                                    <Typography style={{width : '270px'}}>{`${bebida.nombre} $ ${bebida.precio} :`}</Typography>
                                                        <div className={classes.bebida_input}>
                                                            <TextField 
                                                                id={bebida._id}
                                                                type="number"
                                                                 InputLabelProps={{
                                                                        shrink: true,
                                                                }}  
                                                                onChange={bebidaChange}
                                                                name={bebida.nombre } 
                                                                inputProps={
                                                                    {min : "0"}
                                                                }
                                                            />
                                                        </div>
                                                        </div>
                                            }else{
                                                return null
                                            }
                        
                                        })
                                        : <CircularProgress className={classes.circular} color="secondary" />
                                        }
                                        
                                        
                                        </AccordionDetails>
                                   </Accordion>
                                 
                            }) 
                            :<div className={classes.circular}><CircularProgress  color="secondary" /></div>}
            
                      
                    </FormGroup>  
                </Paper>
      
                </div>
                <div>
                    <Button variant="contained" color="primary" fullWidth
                    disabled={(clienteManual.nombre === null && clienteManual.telefono === null ) ||
                        (clienteManual.nombre === "" && clienteManual.telefono === "") ||
                        (clienteManual.telefono === null ) || (cliente.nombre === null) ||
                         (formaentrega === null ) || (formaentrega === "domicilio" && domicilio.calle === null) ||
                         (carrito.length === 0 && formulario[0].platos === null && formulario[0].bebidas.length === 0) 
                         ? true : false   }
                    onClick={()=>confirmarPedido()}>FINALIZAR ORDEN</Button>
                </div>
        </Container>}
        <Dialog
            open={Open}
            
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">{"Confirmar el pedido?"}</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description" className={classes.cabecera}>
                <Typography variant="body2" color="textprimary">Cliente:</Typography>
                <Typography display="block" color="secondary" className={classes.descripcion} >{clienteManual.nombre}</Typography>
                <Typography variant="body2" color="textprimary">Forma Entrega:</Typography>
                {formaentrega === "domicilio" ? 
                <><Typography variant="block" color="secondary" className={classes.descripcion}>Domicilio</Typography> 
                <Typography variant="body2" color="textprimary">Calle:</Typography> 
                <Typography display="block" color="secondary" className={classes.descripcion} >{domicilio.calle ? domicilio.calle : null}</Typography>
                <Typography variant="body2" color="textprimary">Referencia:</Typography>
                <Typography display="block" color="secondary" className={classes.descripcion} >{domicilio.referencia ? domicilio.referencia : "Sin referencia"}</Typography></> 
                : <><Typography variant="body2" color="textprimary" className={classes.descripcion}>TakeAway!!</Typography> </>  }
                    {carrito ? carrito.map(menu =>{
                        return  <Card  key= {menu._id} className = {classes.card}>
                            <CardContent>
                              <Typography variant="h5" component="h2" className={classes.titulo}>
                                    {menu.platos ? menu.platos.nombre : "--"}
                            </Typography>
                            <Typography  color="textSecondary">
                                {menu.ingredientes.length > 0 ? "Ingredientes:" : null}
                            </Typography>
                            {menu.ingredientes.map(ingre =>{
                                return <Typography key ={ingre._id}variant="body2" component="p"className={classes.descripcion}>
                                        {ingre.nombre ? ingre.nombre : " --" }
                                        </Typography>
                            })}
                         
                            <Typography color="textSecondary">
                               {menu.bebidas.length > 0 ? "Bebidas:" : null}
                            </Typography>
                            {menu.bebidas.map(bebida =>{
                                                return <div key = {bebida._id} className={classes.borrarIngrediente}>
                                                            <Typography  variant="body2" component="p" className={classes.descripcion}>
                                                                 {bebida.nombre}
                                                            </Typography>
                                                            <IconButton aria-label="delete" onClick={() => eliminarBebida(bebida._id)} >
                                                                    <DeleteIcon color="error" />
                                                            </IconButton>
                                                       </div>
                                            })}
                            <Typography align="right">
                                Subtotal : $ {
                                   menu.subtotal
                                    
                                }
                            </Typography>
                        </CardContent>
                    <CardActions>
                            <Button size="small" variant="contained" color="secondary" onClick= {e=> eliminarMenu(menu._id)}> Eliminar</Button>
                            <Button size="small" variant="contained" onClick= {e=> duplicateMenu(menu)}> Duplicar</Button>
                </CardActions>
              </Card>
            
                 })
                : null}
         
                     {carrito.length !== 0 ? <Typography align="right" className= {classes.precio} variant="body1">PRECIO FINAL : ${total_carrito}</Typography> : <CircularProgress className={classes.circular} color="secondary" />}
                </DialogContentText>
            </DialogContent>
        <DialogActions>
    <div className={classes.botones}>
    <Button onClick={cancelOrder} color="primary">
        Editar Pedido
      </Button>
      <Button onClick={finalizarPedido} color="primary" variant="contained" autoFocus>
        Confirmar pedido
      </Button>
    </div>
      
    </DialogActions>
  </Dialog>
    </AdminLayout>

     );
}
 
export default NewPedido;